// ======================================================================
// File Name       : ServiceNoticeDetailInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import {
  convertPublicStatus,
  convertUserType,
  convertReleaseTarget,
} from '../../../utils/ServiceUtils';
import { parseDateForDetail, getDisplayPublicPeriod } from '../../../utils/index';

class ServiceNoticeDetailInfo extends React.Component {
  render() {
    const {
      noticeTitle,
      noticeContent,
      publicStatus,
      createdAt,
      authorName,
      publicDateFrom,
      publicDateTo,
      userType,
      releaseTarget,
      isDetail,
      releasePeriod,
    } = this.props;
    let dateFrom = null;
    let dateTo = null;
    if (releasePeriod || isDetail) {
      dateFrom = publicDateFrom;
      dateTo = publicDateTo;
    }
    const releasePeriodTxt = getDisplayPublicPeriod(dateFrom, dateTo);
    return (
      <div>
        <Form className="form-horizontal margin-top-10">
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>タイトル</Col>
              <Col sm={7} as={Form.Label}>{noticeTitle}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>お知らせ内容</Col>
              <Col sm={7} as={Form.Label}>{noticeContent}</Col>
            </Form.Group>
            {isDetail ?
              <Form.Group className="form-info">
                <Col sm={3} as={Form.Label}>公開ステータス</Col>
                <Col sm={7} as={Form.Label}>{convertPublicStatus(publicStatus)}</Col>
              </Form.Group>
            : null}
            {isDetail ?
              <Form.Group className="form-info">
                <Col sm={3} as={Form.Label}>登録日</Col>
                <Col sm={7} as={Form.Label}>{parseDateForDetail(createdAt, 'YYYY/MM/DD')}</Col>
              </Form.Group>
            : null}
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>公開期間</Col>
              <Col sm={7} as={Form.Label}>{releasePeriodTxt}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>公開範囲</Col>
              <Col sm={7} as={Form.Label}>{convertUserType(userType)}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col
                sm={{
                  span: 7,
                  offset: 3
                }}
                as={Form.Label}>
                {convertReleaseTarget(releaseTarget)}
              </Col>
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default ServiceNoticeDetailInfo;
